module.exports = __webpack_public_path__ + "img/25.f10baf30.png";